import { useMemo } from "react";
import { Product } from "./useProductsList";
import { MaybeFieldDefinition } from "../../../toolympus/components/schemed";
import { FieldType } from "../../../toolympus/hooks/useSchema";
import { schemaWithConfigurableFields } from "../../../toolympus/components/ConfigurableForms/useConfigurableFormSubmissions";

export const useProductSubmissionsFields = (product: Product) => {
  const [schema, fields] = useMemo(() => {
    const schema = schemaWithConfigurableFields({}, product.fields || []);

    const fields: MaybeFieldDefinition[] = (product.fields || []).map(f => [f._id]);

    return [
      schema,
      fields,
    ]
  }, [product.fields]);

  return {
    schema,
    fields,
    simpleFields: fields.filter(f => !!f && !!schema[f[0]] && schema[f[0]].type !== FieldType.bool),
  }
}
